import React from 'react'
import Calendar_StripTwo from '../../../components/shared/calendar/calender_stripTwo'
import { TouchableOpacity, View, Text, ScrollView } from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import Card from '../../../components/shared/card/Card'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import { useTranslation } from 'react-i18next'
import { useLabourStore } from '../../../stores/labour'
import { Ionicons } from '@expo/vector-icons'

const TimeCard = ({ navigation, route }: any): JSX.Element => {
    const { customerShifts } = route.params
    const [nextshift, setNextshift] = React.useState('')
    const handleWeekChange = () => { }
    const changeCalendarLabel = () => { }
    const { t } = useTranslation()
    const labourStore = useLabourStore()
    return (
        <ScrollView>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel={"Home"}
                        title={t('Timecard')}
                    />
                </View>
            </View>
            <View style={[globalStyles.containerOverlap]}>
                <Card>
                    <Calendar_StripTwo
                        onChangeValue={changeCalendarLabel}
                        shiftInfo={true}
                        shiftInfoText={`${nextshift}`}
                        shiftLable={"Timecard"}
                        key={labourStore?.startdayofweekdata?.payPeriodDay}

                    />
                </Card>
            </View>
        </ScrollView>

    )
}

export default TimeCard
